import React, { useEffect, useState } from "react";
import "../css/tollfreenumber.css";

const TollFreeNumber = () => {
const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const loopInterval = setInterval(() => {
      const expandTimer = setTimeout(() => {
        setExpanded(true);
      }, 1000); 

      const collapseTimer = setTimeout(() => {
        setExpanded(false);
      }, 5000); 

      return () => {
        clearTimeout(expandTimer);
        clearTimeout(collapseTimer);
      };
    }, 6000); 

    return () => clearInterval(loopInterval);
  }, []);

  return (
    <div className={`tollfree-container ${expanded ? "expanded" : "collapsed"}`}>
      <a href="tel:18003157480" className="tollfree-link">
        <span className="phone-icon">
          <i className="fa fa-phone"></i>
        </span>
        {expanded && <span className="phone-text">Call Now: 18005703990</span>}
      </a>
    </div>
  );
};

export default TollFreeNumber;

